import { Controller } from '@hotwired/stimulus';

export default class IncrementingInputControlller extends Controller {
  declare private readonly stepValue: number;
  declare private readonly inputTarget: HTMLInputElement;

  public static readonly values = {
    step: { type: Number, default: 1 }
  };

  public static readonly targets = ['input'];

  private get _inputValue(): number {
    return this.inputTarget.valueAsNumber || 0;
  }

  private set _inputValue(value: number) {
    this.inputTarget.valueAsNumber = value;
    this.inputTarget.dispatchEvent(new Event('change'));
  }

  public increment(): void {
    const currentValue = this._inputValue;

    this._inputValue = currentValue + this.stepValue;

    if (!this.inputTarget.checkValidity()) {
      this._inputValue = currentValue;
    }
  }

  public decrement(): void {
    const currentValue = this._inputValue;

    this._inputValue = currentValue - this.stepValue;

    if (!this.inputTarget.checkValidity()) {
      this._inputValue = currentValue;
    }
  }
}
